import { render, staticRenderFns } from "./ConfirmClear.vue?vue&type=template&id=b08a0942&scoped=true"
import script from "./ConfirmClear.vue?vue&type=script&lang=js"
export * from "./ConfirmClear.vue?vue&type=script&lang=js"
import style0 from "./ConfirmClear.vue?vue&type=style&index=0&id=b08a0942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08a0942",
  null
  
)

export default component.exports